<div style="display: block;" *ngIf="exerciseHistories.length > 1">
  <ion-item>
    <ion-label>Filter by Plan</ion-label>
    <ion-select [(ngModel)]="selectedPlanId" (ionChange)="filterDataByPlan()">
      <!-- "All" option to display all data -->
      <ion-select-option value="">All</ion-select-option>
      <!-- Dynamically generated plan options -->
      <ion-select-option *ngFor="let planId of distinctPlanIds" [value]="planId">
        {{ getPlanName(planId) }}
      </ion-select-option>
    </ion-select>
  </ion-item>


  <canvas baseChart
    [data]="lineChartData"
    [options]="lineChartOptions"
    [type]="lineChartType">
  </canvas>

</div>

<div *ngIf="exerciseHistories.length <= 1">Not enugu data for chart.</div>
